// https://github.com/verlok/lazyload
import LazyLoad from "vanilla-lazyload";
import DOMUpdateEvent from '../../rankers/helpers/dom_update_event';

// The LazyLoader class takes a selector (eg '.lazy_load`) and handles instantiating LazyLoad on them.
export default class LazyLoader {

    constructor(selector = '.lazy_load') {
        this.selector = selector;

        this.lazyLoad = null;
        this.parentLazyLoad = null;

        this.initLazyLoad();
        this.handleDOMUpdate();
        this.handlePageUpdate();
    }

    initLazyLoad() {
        // Lazy load elements with the selector.
        this.lazyLoad = new LazyLoad({
            elements_selector: this.selector
        });

        // Lazy load parent containers and their children.
        this.parentLazyLoad = new LazyLoad({
            elements_selector: `${this.selector}--parent`,
            // When the container div enters the viewport we fire the callback...
            callback_enter: (el) => {
                new LazyLoad({
                    container: el,
                    elements_selector: `${this.selector}--child`
                });
            },
            unobserve_entered: true // Stop observing after they entered
        });
    }

    handleDOMUpdate() {
        new DOMUpdateEvent().listen(this.update.bind(this));
    }

    handlePageUpdate() {
        if (!document || !document.body) return;
        this.mutationObserver = new MutationObserver(this.update.bind(this));
        this.mutationObserver.observe(document.body, {childList: true, subtree: true});
    }

    update() {
        this.lazyLoad.update();
        this.parentLazyLoad.update();
    }

}




